/* Tierra Verde - los formularios con selector de "packs" (marcados con
   data-tv-pack-replace: la pagina de producto y la barra fija de compra)
   reemplazan la cantidad del producto en el carrito en vez de sumarla.

   Sin esto: si el cliente elige "1 caja" y compra, y luego elige "3 cajas"
   y compra de nuevo, el carrito queda con 4 cajas (1 + 3), porque el
   <product-form> de Dawn siempre hace /cart/add.js, que suma. Con esto: el
   carrito queda exactamente en la cantidad del pack elegido, usando
   /cart/update.js con la cantidad final en vez de sumar.

   El envio del formulario se intercepta en fase de captura (mas arriba en
   el arbol que el propio <form>) para que esta funcion corra ANTES que el
   listener de envio que pone Dawn directo en el <form>, y stopImmediatePropagation
   evita que ese listener de Dawn llegue a correr (si corriera, se haria
   ademas un /cart/add.js normal, duplicando el agregado). Al terminar, se
   usa el mismo cart-drawer y las mismas secciones que ya usa Dawn, asi el
   carrito lateral se abre y se actualiza exactamente igual que siempre. */
(function () {
  'use strict';

  document.addEventListener(
    'submit',
    function (evento) {
      var form = evento.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.closest('[data-tv-pack-replace]')) return;

      evento.preventDefault();
      evento.stopImmediatePropagation();

      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput || !qtyInput) return;

      var productForm = form.closest('product-form');
      var submitButton = form.querySelector('[type="submit"]');
      if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

      var hideErrors = !!(productForm && productForm.dataset.hideErrors === 'true');
      var errorWrapper = form.querySelector('.product-form__error-message-wrapper');
      var errorMessage = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;
      var spinner = form.querySelector('.loading__spinner');
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      var variantId = idInput.value;
      var cantidad = parseInt(qtyInput.value, 10) || 1;

      function mostrarError(texto) {
        if (hideErrors || !errorWrapper || !errorMessage) return;
        errorMessage.textContent = texto;
        errorWrapper.removeAttribute('hidden');
      }

      if (errorWrapper && !hideErrors) errorWrapper.setAttribute('hidden', 'hidden');
      if (submitButton) {
        submitButton.setAttribute('aria-disabled', 'true');
        submitButton.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');
      if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);

      var payload = { updates: {}, sections_url: window.location.pathname };
      payload.updates[variantId] = cantidad;
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (seccion) {
          return seccion.id;
        });
      }

      fetch(window.routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify(payload) }))
        .then(function (r) {
          return r.json();
        })
        .then(function (respuesta) {
          if (respuesta.status || respuesta.errors) {
            mostrarError(respuesta.description || respuesta.message || String(respuesta.errors));
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'tv-pack-replace',
                productVariantId: variantId,
                errors: respuesta.errors || respuesta.description,
                message: respuesta.message,
              });
            }
            return;
          }

          if (cart && typeof cart.renderContents === 'function') cart.renderContents(respuesta);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'tv-pack-replace',
              productVariantId: variantId,
              cartData: respuesta,
            });
          }
        })
        .catch(function (e) {
          console.error(e);
          mostrarError('No pudimos actualizar el carrito. Intenta de nuevo.');
        })
        .finally(function () {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
          if (cart && cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    },
    true
  );
})();

/* Tierra Verde - sube el boton flotante de WhatsApp cuando la barra fija de
   compra (tv-barra-compra) esta visible, para que no la tape. Vuelve a su
   posicion normal cuando la barra se esconde. */
(function () {
  'use strict';

  function ajustar() {
    var wa = document.querySelector('.wa-flotante');
    var barra = document.querySelector('[data-tv-buybar]');
    if (!wa) return;

    if (!wa.dataset.tvBottomBase) {
      wa.dataset.tvBottomBase = window.getComputedStyle(wa).bottom;
    }

    if (barra && barra.classList.contains('tv-buybar--visible') && barra.offsetHeight) {
      wa.style.setProperty('bottom', barra.offsetHeight + 12 + 'px', 'important');
    } else {
      wa.style.setProperty('bottom', wa.dataset.tvBottomBase, 'important');
    }
  }

  function iniciar() {
    var barra = document.querySelector('[data-tv-buybar]');
    if (barra && 'MutationObserver' in window) {
      new MutationObserver(ajustar).observe(barra, { attributes: true, attributeFilter: ['class'] });
    }
    ajustar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  window.addEventListener('load', ajustar);
  window.addEventListener('resize', ajustar);
})();

/* Tierra Verde - reveal-on-scroll for tv-* sections. */
(function () {
  'use strict';

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(nodes) {
    nodes.forEach(function (node) {
      node.classList.add('tv-reveal--in');
    });
  }

  function init() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.tv-reveal'));
    if (!nodes.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tv-reveal--in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });

    document.addEventListener('shopify:section:load', function () {
      revealAll(
        Array.prototype.slice.call(document.querySelectorAll('.tv-reveal:not(.tv-reveal--in)'))
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Tierra Verde - carrito lateral.
   Garantiza que el icono de la bolsa abra el panel en vez de ir a /cart.
   Si el panel no esta disponible, deja que el enlace navegue normalmente. */
(function () {
  'use strict';

  function abrir(panel, disparador) {
    try {
      panel.open(disparador);
    } catch (err) {
      panel.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
  }

  function enlazar() {
    var panel = document.querySelector('cart-drawer');
    var icono = document.getElementById('cart-icon-bubble');

    if (!panel || !icono) return;
    if (icono.getAttribute('data-tv-cart-bound') === '1') return;

    icono.setAttribute('data-tv-cart-bound', '1');
    icono.setAttribute('role', 'button');
    icono.setAttribute('aria-haspopup', 'dialog');

    icono.addEventListener(
      'click',
      function (event) {
        if (typeof panel.open !== 'function') return;
        event.preventDefault();
        abrir(panel, icono);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enlazar);
  } else {
    enlazar();
  }

  window.addEventListener('load', enlazar);
  document.addEventListener('shopify:section:load', enlazar);
})();

/* Tierra Verde - contenido del carrito lateral.

   1) Barra de avance hacia el envio gratis. Mejora el aviso que ya pinta
      Liquid: le agrega icono, texto mas directo y una barra. El numero de
      cajas se lee del contador de la bolsa, que Shopify vuelve a pintar en
      cada cambio del carrito.

   2) Aviso de aceptacion de terminos, justo encima del boton de pagar. En la
      pagina /cart lo pinta Liquid (snippet tv-aviso-terminos); aqui se agrega
      al cajon, que de por si solo existe con JavaScript activo.

   3) Reserva del alto del bloque de botones, para que el pie del cajon no
      salte mientras Shopify vuelve a pintar su contenido.
*/
(function () {
  'use strict';

  var MINIMO = 5; // cajas necesarias para el envio gratis
  var altoCtas = 0; // alto del bloque de botones ya completo

  function cajasEnCarrito() {
    var burbuja = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (!burbuja) return null;
    var n = parseInt(String(burbuja.textContent).replace(/\D/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  function ponerAvisoTerminos() {
    var ctas = document.querySelector('cart-drawer .cart__ctas');
    if (!ctas) return;
    if (ctas.querySelector('.tv-aviso-terminos')) return;

    var p = document.createElement('p');
    p.className = 'tv-aviso-terminos';
    p.innerHTML =
      'Al hacer el pedido aceptas nuestros ' +
      '<a href="/policies/terms-of-service">Términos y Condiciones</a>' +
      ' y la <a href="/policies/refund-policy">Política de reembolsos</a>.';

    // Va encima del boton de pagar.
    ctas.insertBefore(p, ctas.firstChild);
  }

  function pintarAvisoEnvio() {
    var caja = document.querySelector('cart-drawer .tv-envio-mensaje');
    if (!caja) return;

    var n = cajasEnCarrito();
    if (n === null) return;

    if (caja.getAttribute('data-tv-n') === String(n)) return;
    caja.setAttribute('data-tv-n', String(n));

    var faltan = Math.max(0, MINIMO - n);
    var pct = Math.max(6, Math.min(100, Math.round((n / MINIMO) * 100)));

    var texto;
    if (faltan === 0) {
      texto = '¡Listo! Tu pedido tiene envío GRATIS';
    } else if (faltan === 1) {
      texto = 'Te falta 1 caja para el envío GRATIS';
    } else {
      texto = 'Te faltan ' + faltan + ' cajas para el envío GRATIS';
    }

    caja.classList.add('tv-envio--mejorado');
    caja.classList.toggle('tv-envio-mensaje--lograda', faltan === 0);
    caja.classList.toggle('tv-envio-mensaje--pendiente', faltan > 0);

    caja.innerHTML =
      '<span class="tv-envio__fila">' +
      '<span class="tv-envio__icono" aria-hidden="true">' +
      (faltan === 0 ? '🎉' : '🚚') +
      '</span>' +
      '<span class="tv-envio__texto"></span>' +
      '</span>' +
      '<span class="tv-envio__barra"><span class="tv-envio__relleno"></span></span>' +
      '<span class="tv-envio__paso"></span>';

    caja.querySelector('.tv-envio__texto').textContent = texto;
    caja.querySelector('.tv-envio__relleno').style.width = pct + '%';
    caja.querySelector('.tv-envio__paso').textContent =
      Math.min(n, MINIMO) + ' de ' + MINIMO + ' cajas';
  }

  function reservarEspacio() {
    var panel = document.querySelector('cart-drawer');
    if (!panel) return;
    var ctas = panel.querySelector('.cart__ctas');
    if (!ctas) return;

    // Solo se mide cuando el bloque ya esta completo (con el aviso puesto).
    if (ctas.querySelector('.tv-aviso-terminos') || ctas.querySelector('.terms_and_conditions')) {
      var h = Math.ceil(ctas.getBoundingClientRect().height);
      if (h > altoCtas) altoCtas = h;
    }

    if (altoCtas > 0) {
      panel.style.setProperty('--tv-ctas-alto', altoCtas + 'px');
    }
  }

  function actualizar() {
    ponerAvisoTerminos();
    pintarAvisoEnvio();
    reservarEspacio();
  }

  function vigilar() {
    var panel = document.querySelector('cart-drawer');
    if (!panel || panel.getAttribute('data-tv-obs') === '1') return;
    panel.setAttribute('data-tv-obs', '1');

    actualizar();

    if ('MutationObserver' in window) {
      // Solo childList/subtree: los cambios de atributo (la variable CSS que
      // escribimos sobre el panel) no vuelven a disparar el observador.
      new MutationObserver(actualizar).observe(panel, { childList: true, subtree: true });
    }

    // Si cambia el ancho, el alto guardado puede quedar corto: se vuelve a medir.
    window.addEventListener('resize', function () {
      altoCtas = 0;
      panel.style.removeProperty('--tv-ctas-alto');
      setTimeout(reservarEspacio, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vigilar);
  } else {
    vigilar();
  }

  window.addEventListener('load', vigilar);
  document.addEventListener('shopify:section:load', vigilar);
})();

/* Tierra Verde - selector de "packs" (cantidad de cajas con precio propio).

   Se usa en la pagina de producto (lista de packs) y en la barra de compra
   fija (los 4 cuadritos), que son dos secciones de Liquid distintas y por
   lo tanto no comparten estado por si solas. Este elemento manda un evento
   compartido cada vez que alguien elige un pack, y ambos escuchan ese mismo
   evento: elegir un pack en cualquiera de los dos actualiza al otro.

   Contrato de marcado que espera cada instancia (los nombres de clase y
   estilos visuales de cada seccion no cambian, solo se agregan estos
   enganches genericos):
     - un <input type="hidden" class="tv-pack-selector__cantidad"> con la
       cantidad que se va a agregar al carrito
     - un <input type="radio" class="tv-pack-selector__input"> por pack,
       con value = cantidad de cajas y data-total = precio total ya formateado
     - el elemento que se marca como elegido (la tarjeta o el cuadrito)
       lleva el atributo data-tv-pack-item
     - opcional: dentro del mismo <form>, un elemento con data-tv-pack-label
       y data-base con el texto fijo del boton, para agregarle " · $total" */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('tv-pack-selector')) return;

  var EVENTO = 'tv:pack-qty';

  customElements.define(
    'tv-pack-selector',
    class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.cantidad = this.querySelector('.tv-pack-selector__cantidad');
        this.opciones = Array.prototype.slice.call(
          this.querySelectorAll('.tv-pack-selector__input')
        );

        var form = this.closest('form');
        this.etiqueta = form ? form.querySelector('[data-tv-pack-label]') : null;

        this.opciones.forEach(function (opcion) {
          opcion.addEventListener('change', function () {
            if (!opcion.checked) return;
            self.aplicar(opcion);
            document.dispatchEvent(new CustomEvent(EVENTO, { detail: { cantidad: opcion.value } }));
          });
        });

        this._sincronizar = function (evento) {
          var detalle = evento.detail || {};
          if (detalle.cantidad == null) return;
          var opcion = self.opciones.filter(function (o) {
            return o.value === String(detalle.cantidad);
          })[0];
          if (opcion && !opcion.checked) self.aplicar(opcion);
        };
        document.addEventListener(EVENTO, this._sincronizar);
      }

      disconnectedCallback() {
        document.removeEventListener(EVENTO, this._sincronizar);
      }

      aplicar(opcion) {
        if (this.cantidad) this.cantidad.value = opcion.value;
        this.opciones.forEach(function (o) {
          o.checked = o === opcion;
          var item = o.closest('[data-tv-pack-item]');
          if (item) item.classList.toggle('is-selected', o === opcion);
        });
        if (this.etiqueta && this.etiqueta.dataset.base) {
          this.etiqueta.textContent = this.etiqueta.dataset.base + ' · ' + opcion.dataset.total;
        }
      }
    }
  );
})();

/* Tierra Verde - la pagina /cart abre el carrito lateral.

   Se cae en esa pagina al volver del checkout o al escribir /cart, y la tabla
   ancha de Dawn no se parece en nada al resto de la tienda. En vez de eso se
   abre el mismo panel lateral y se esconde el contenido de la pagina detras.

   Al cerrar el panel se devuelve a la pagina de donde vino (normalmente el
   checkout, con los datos que ya habia escrito). Si no hay de donde volver, o
   el carrito quedo vacio, se va a la tienda.

   La regla que esconde el contenido la crea este archivo, no la hoja de
   estilos: asi, sin JavaScript, la pagina /cart se ve completa y sirve igual.
   Y si el panel no alcanza a abrir, la red de seguridad la vuelve a mostrar.
*/
(function () {
  'use strict';

  if (!/(^|\/)cart\/?$/.test(window.location.pathname)) return;

  var raiz = document.documentElement;
  var CLASE = 'tv-carrito-panel';
  var estuvoAbierto = false;
  var saliendo = false;

  function esconderPagina() {
    if (!document.getElementById('tv-carrito-panel-css')) {
      var estilo = document.createElement('style');
      estilo.id = 'tv-carrito-panel-css';
      estilo.textContent = '.' + CLASE + ' #MainContent { visibility: hidden; }';
      (document.head || raiz).appendChild(estilo);
    }
    raiz.classList.add(CLASE);
  }

  function mostrarPagina() {
    raiz.classList.remove(CLASE);
  }

  function sePuedeVolver() {
    var panel = document.querySelector('cart-drawer');
    if (panel && panel.classList.contains('is-empty')) return false;

    var vengoDe = document.referrer || '';
    if (!vengoDe) return false;
    // Si la pagina anterior era esta misma (una recarga), volver no sirve.
    if (vengoDe.split('#')[0] === window.location.href.split('#')[0]) return false;

    return window.history.length > 1;
  }

  function salir() {
    if (saliendo) return;
    saliendo = true;

    if (sePuedeVolver()) {
      window.history.back();
      return;
    }

    window.location.href = '/';
  }

  function vigilarCierre(panel) {
    if (!('MutationObserver' in window)) return;

    new MutationObserver(function () {
      if (panel.classList.contains('active')) {
        estuvoAbierto = true;
        return;
      }
      if (!estuvoAbierto) return;
      // Se confirma el cierre antes de navegar: Shopify vuelve a pintar el
      // contenido del cajon cada vez que cambia el carrito.
      setTimeout(function () {
        if (!panel.classList.contains('active')) salir();
      }, 150);
    }).observe(panel, { attributes: true, attributeFilter: ['class'] });
  }

  function abrirPanel() {
    var panel = document.querySelector('cart-drawer');

    if (!panel || typeof panel.open !== 'function') {
      mostrarPagina();
      return;
    }

    esconderPagina();
    vigilarCierre(panel);

    try {
      panel.open();
    } catch (err) {
      mostrarPagina();
    }
  }

  function esperarPanel() {
    // El elemento <cart-drawer> se activa cuando corre cart-drawer.js, que
    // puede llegar despues que este archivo. Se espera a que exista.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-drawer').then(abrirPanel);
      setTimeout(abrirPanel, 800);
    } else {
      abrirPanel();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', esperarPanel);
  } else {
    esperarPanel();
  }

  // Red de seguridad: si el panel no quedo abierto, la pagina se ve normal.
  setTimeout(function () {
    var panel = document.querySelector('cart-drawer');
    if (!panel || !panel.classList.contains('active')) mostrarPagina();
  }, 2500);
})();
